<template>
    <div class="pt-3 hm-fs-12">
        <!-- Display ticket status -->
        <div class="row mb-2">
            <label for="ticket-status" class="col-md-5 label">Ticket Status</label>
            <div class="form-check form-switch col-md-7">
                <input class="form-check-input" type="checkbox" role="switch" id="ticket_status" name="ticket_status" v-model="status">
                <label class="form-check-label" for="ticket_status">{{ $capitalize(ticket.status) }}</label>
            </div>
        </div>
        <div class="row mb-2">
            <label for="order-number" class="col-md-5 label">Ticket Number</label>
            <div class="col-md-7">{{ ticket.ticket_number }}</div>
        </div>
        <template v-if="typeof ticket.order !== 'undefined' && ticket.order !== null">
            <!-- Display order number if it exists -->
            <div class="row mb-2">
                <label for="order-number" class="col-md-5 label">Order Number</label>
                <div class="col-md-7">{{ ticket.order.order_number }}</div>
            </div>

            <!-- Display order date if it exists -->
            <div class="row mb-2">
                <label for="order-date" class="col-md-5 label">Order Date</label>
                <div class="col-md-7">{{ $dateTimeFormat(ticket.order.created_at, 'DD MMM YY') }}</div>
            </div>

            <!-- Display order status if it exists -->
            <div class="row mb-2">
                <label for="order-status" class="col-md-5 label">Order Status</label>
                <div class="col-md-7">{{ $capitalize(ticket.order.status) }}</div>
            </div>
            <!-- Check if order address exists -->
            <template v-if="typeof ticket.order.address !== 'undefined' && ticket.order.address !== null">
                <!-- Display order postal code -->
                <div class="row mb-2">
                    <label for="order-postal-code" class="col-md-5 label">Order Postal Code</label>
                    <div class="col-md-7">{{ ticket.order.address.postal_code }}</div>
                </div>
                <!-- Display order address if it exists -->
                <div class="row mb-2">
                    <label for="order-address" class="col-md-5 label">Order Address</label>
                    <div class="col-md-7">{{ ticket.order.address.full_address }}</div>
                </div>
            </template>

            <!-- Display order handyman name if it exists -->
            <template v-if="typeof ticket.order.handymans !== 'undefined' && ticket.order.handymans !== null">
                <div class="row mb-2">
                    <label for="order-handyman" class="col-md-5 label">Assigned To</label>
                    <div class="col-md-7">
                        <!-- iterate the order handymans and display the name -->
                            <template v-for="(handyman, index) in ticket.order.handymans">
                            <span>{{ $capitalize(handyman.first_name + ' ' + handyman.last_name).trim() }}</span>
                            <span v-if="index < ticket.order.handymans.length - 1">, </span>
                        </template>
                    </div>
                </div>
            </template>
            <!-- Display order amount if it exists and user is provider -->
            <div v-if="user.parent_id == null" class="row mb-2">
                <label for="order-address" class="col-md-5 label">Order Amount</label>
                <div class="col-md-7">{{ currency }}{{ ticket.order.final_amount }}</div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: "TicketDetails",
    props: {
        user: {
            type: Object,
            required: true
        },
        ticket: {
            type: Object,
            required: true
        },
        ticketStatus: {
            type: Boolean
        },
        currency: {
            type: String,
            default: '£'
        }
    },
    data() {
        return {
            status: this.ticketStatus
        }
    },
    watch: {
        status: function(newVal, oldVal) {
            this.$emitter.emit('updateTicketStatus', newVal);
        }
    }
}
</script>
